import Manager from '@modifi/plugin-manager'

import '@modifi/plugin-dialogs/register'
import './cms-components/iframe-dialog/dialog-setup'

import {PLUGIN_NAME} from './constants/routes'
import reducer from './data/reducer'

if (!Manager.isRegistered(PLUGIN_NAME)) {
  Manager.registerPlugin(PLUGIN_NAME)

  // @ts-expect-error wrong typing in @modifi/plugin-manager
  Manager.addReducer(PLUGIN_NAME, reducer)
}

export * from './index'
